import App from "app";
import { authenticateForMcpToken } from "core/services/securityService/mcp-token-service";

export interface McpTokenResult {
    token: string;
    host: string;
    mcpUrl: string;
}

export interface McpTokenService {
    generateToken: (password: string) => Promise<McpTokenResult>;
}

const defaultMcpTokenService: McpTokenService = {
    generateToken: async (password: string) => {
        const username = App.user?.name;
        if (!username) {
            throw new Error("User not authenticated");
        }
        const token = await authenticateForMcpToken(username, password);
        const host = window.location.hostname;
        return {
            token,
            host,
            mcpUrl: `http://${host}:9080/mcp`
        };
    }
};

export default defaultMcpTokenService;
